var map = {
	"./1.png": "9c3c",
	"./2.png": "a808",
	"./3.png": "e344",
	"./4.png": "dd83",
	"./5.png": "dbb1",
	"./6.png": "9652",
	"./7.png": "4051"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bba4";